export enum BackgroundColor {
  WHITE = 'white',
}
